import styled, { css } from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';
import { CloseIcon } from '@/shared/images/icons/CloseIcon';

export const Container = styled.div<{ isFull: boolean }>`
    max-height: 100px;
    margin-bottom: 40px;
    display: flex;
    gap: 6px;
    ${Screen.ipad} {
        max-height: 140px;
        gap: 8px;
    }
    ${Screen.desktop} {
        max-height: 140px;
        gap: 16px;
    }

    picture {
        ${({ isFull }) =>
            isFull
                ? `width: 100%`
                : css`
                      max-width: 100px;
                      ${Screen.ipad} {
                          max-width: 140px;
                      }
                      ${Screen.desktop} {
                          max-width: 140px;
                      }
                  `}
    }

    *:first-child {
        ${({ isFull }) =>
            isFull
                ? `width: 100%`
                : css`
                      max-width: 100px;
                      ${Screen.ipad} {
                          max-width: 140px;
                      }
                      ${Screen.desktop} {
                          max-width: 140px;
                      }
                  `}
    }
`;

export const ImageItem = styled.picture`
    width: 100%;
    border-radius: ${radius.small};
    overflow: hidden;
    position: relative;
    cursor: pointer;
    aspect-ratio: 1 / 1;
`;

export const VideoItem = styled.div`
    border-radius: ${radius.small};
    overflow: hidden;
    position: relative;
    cursor: pointer;
    aspect-ratio: 1 / 1;
    width: 100%;
    height: 100%;

    *:first-child {
        height: 100%;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(180deg, rgba(12, 11, 11, 0) 32%, rgba(0, 0, 0, 0.4) 74%);
    }
`;

export const RestNumber = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    ${Text.Full.heading2}

    &:hover {
        text-decoration: underline;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 0 16px;

    ${Screen.desktop} {
        ::-webkit-scrollbar {
            width: 6px;
        }
        ::-webkit-scrollbar-track {
            background-color: ${cssVars.bg_ash_blueDark};
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
            height: 30px;
            background: ${Palette.gray.gray3};
            border-radius: 10px;
        }
    }
`;

export const Modal = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${cssVars.bg_white_dark3};
    width: 100%;
    max-width: 1000px;
    position: relative;
    margin: auto;
    box-sizing: border-box;
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_modal};
    padding: 4px 6px 16px 8px;

    ${Screen.ipad} {
        padding: 8px 12px 32px 16px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 4px 6px;
`;

export const SubHeading = styled.div`
    ${Text.Full.large.semibold};
    color: ${cssVars.fg_gray1_white};
    margin-right: 16px;
    flex: 1;
`;

export const GridWrap = styled.div`
    max-height: 54vh;
    overflow-y: auto;
    padding-right: 4px;

    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-track {
        background-color: ${cssVars.bg_ash_blueDark};
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        height: 30px;
        background: ${Palette.gray.gray3};
        border-radius: 10px;
    }
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;

    ${Screen.desktop} {
        grid-template-columns: repeat(5, 1fr);
    }
`;

export const CloseButtonWithIcon = styled(CloseIcon)``;

export const CloseButton = styled.div<{
    onClick: () => void;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: ${cssVars.bg_ash_normal};
    border-radius: ${radius.huge};
    cursor: pointer;

    ${Screen.ipad} {
        width: 36px;
        height: 36px;
    }

    &:hover {
        background: ${cssVars.bg_white_dark3};
        box-shadow: ${cssVars.shadow_card_default};
    }
`;
